import RequestMoney from ".";

const EnhancementRequestMoney = () => {
  return <RequestMoney />;
};

export default EnhancementRequestMoney;
